module.exports = __webpack_public_path__ + "img/1591656931.60cd7cf1.jpg";